import { schema } from "normalizr";
import { Warehouse as WarehouseRecord } from "records/warehouse";

export const Warehouse = new schema.Entity(
    "warehouses",
    {},
    {
        idAttribute: "id",
    }
);

(Warehouse as any).record = WarehouseRecord;
